export default class NewsTiles {
    constructor() {
        this.fetchDomElements();
        this.addAdvertisementHelperClass();
    }

    fetchDomElements() {
        this.domElements = {
            newsTiles: document.querySelectorAll('.newsTiles')[0],
        };
    }

    addAdvertisementHelperClass() {
        let tile2 = this.domElements.newsTiles.querySelectorAll('.tile2')[0];

        if (tile2.classList.contains('advertisement')) {
            let layout = this.domElements.newsTiles.querySelectorAll('.layoutContainer')[0]
            layout.classList.add('hasAdvertisementTile');
        }
    }
}
